export const parseJSON = (...args) => {
  try {
    return JSON.parse(...args);
  } catch (e) {
    return undefined;
  }
};
